import moment from 'moment';
import { timestampToDateTime } from './getDateTime';
import { timeDurationTools } from './timeDurationTools';

export const isOneWeekOrLess = (currentDate) => {
  if (currentDate.timeDuration)
    return ['today', '6h', '24h', '1w'].includes(currentDate.timeDuration);

  return (
    moment(timestampToDateTime(currentDate.toDate)).diff(
      timestampToDateTime(currentDate.fromDate),
      'seconds'
    ) <= timeDurationTools('1w').toNumber()
  );
};

export const isMoreThanOneWeek = (currentDate) => {
  if (currentDate.timeDuration)
    return ['2w', '1m', '3m'].includes(currentDate.timeDuration);

  return (
    moment(timestampToDateTime(currentDate.toDate)).diff(
      timestampToDateTime(currentDate.fromDate),
      'seconds'
    ) > timeDurationTools('1w').toNumber()
  );
};

export const isMoreThanThreeMonth = (currentDate) => {
  if (currentDate.timeDuration)
    return ['6m', '12m'].includes(currentDate.timeDuration);

  return (
    moment(timestampToDateTime(currentDate.toDate)).diff(
      timestampToDateTime(currentDate.fromDate),
      'seconds'
    ) > timeDurationTools('3m').toNumber()
  );
};
